import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { fetchMe } from "../lib/auth";
import SignIn from "../pages/SignIn";

// Gate: verifies the session server-side before rendering the portfolio.
export default function Protected({ children }) {
  const location = useLocation();
  const [state, setState] = useState(location.state?.user ? "ok" : "checking");

  useEffect(() => {
    if (location.state?.user) return; // user data passed from AuthCallback
    fetchMe()
      .then(() => setState("ok"))
      .catch(() => setState("denied"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (state === "checking") {
    return (
      <div className="min-h-screen bg-canvas flex items-center justify-center" data-testid="auth-checking">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-faint">Checking access…</p>
      </div>
    );
  }
  if (state === "denied") return <SignIn />;
  return children;
}
